export const BASE_MAX_SIZE=1680;export const BASE_GRID_SIZE=7;export const BASE_FONT_SIZE=16;export const BASE_TO_REM=BASE_GRID_SIZE/BASE_FONT_SIZE;